import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { Panel, PanelSection } from 'foundations-components/transitional/components/Panel';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { useQueryParamString } from '../../hooks/useQueryParams';
import { useTempFilters } from '../../hooks/useTempFilters';
import { useActiveViewId } from '../../hooks/viewTabs';
import ErrorBoundary from '../ErrorBoundary';
import AdvancedFiltersAsync from './AdvancedFiltersAsync';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AdvancedFiltersPanel() {
  const viewId = useActiveViewId();
  const crmSearchFilters = useTempFilters(viewId);
  const history = useHistory();
  const location = useLocation();
  const queryParamsString = useQueryParamString();
  const handleCloseButtonClick = useCallback(() => {
    const updatedPath = location.pathname.replace(/\/filters/, '');
    history.replace(`${updatedPath}${queryParamsString}`);
  }, [history, location.pathname, queryParamsString]);
  return /*#__PURE__*/_jsxs(Panel, {
    "data-selenium-test": "advanced-filters-panel",
    width: 500,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      "data-selenium-test": "advanced-filters-panel-close-button",
      onClick: handleCloseButtonClick
    }), /*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "filterSidebar.title"
        })
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: /*#__PURE__*/_jsx(PanelSection, {
        paddingInlineStart: "1100",
        marginBlockEnd: "0",
        height: "100%",
        children: /*#__PURE__*/_jsx(View, {
          blockSize: "100vh",
          children: /*#__PURE__*/_jsx(ErrorBoundary, {
            boundaryName: "advanced-filters-panel",
            children: /*#__PURE__*/_jsx(AdvancedFiltersAsync, {
              crmSearchFilters: crmSearchFilters,
              viewId: viewId
            })
          })
        })
      })
    })]
  }, "tasks-advanced-filters-panel");
}